<template>
    <el-container style="height: 100vh">
      <!-- 左侧菜单 -->
      <el-aside width="200px" class="sidebar">
        <div class="logo">管理后台</div>
        <el-menu
          :default-active="$route.path"
          router
          background-color="#001529"
          text-color="#fff"
          active-text-color="#409eff"
        >
          <el-menu-item index="/admin/product">产品管理</el-menu-item>
          <el-menu-item index="/admin/news">新闻管理</el-menu-item>
          <el-menu-item index="/admin/partner">合作伙伴</el-menu-item>
          <el-menu-item index="/admin/company">公司信息</el-menu-item>
          <el-menu-item index="/admin/contact">联系人管理</el-menu-item>
          <el-menu-item index="/admin/landscape">风貌照片管理</el-menu-item>
          <el-menu-item index="/admin/userContactHistory">历史联系信息</el-menu-item>
          
        </el-menu>
      </el-aside>
  
      <!-- 右侧主体 -->
      <el-container>
        <el-header class="header">
          <span class="title">公司官网后台管理</span>
          <el-button type="text" @click="logout">退出</el-button>
        </el-header>
        <el-main class="main">
          <div class="content-wrapper">
            <router-view />
          </div>
        </el-main>
      </el-container>
    </el-container>
  </template>
  
  <script>
  export default {
    name: "AdminLayout",
    methods: {
      logout() {
        localStorage.removeItem("token");
        this.$router.push("/admin/login");
      }
    }
  };
  </script>
  
  <style scoped>
  .sidebar {
    background: #001529;
    color: #fff;
    display: flex;
    flex-direction: column;
  }
  
  .logo {
    height: 60px;
    line-height: 60px;
    color: #fff;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    background: #002140;
  }
  
  .header {
    background: #fff;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 8px #f0f1f2;
    position: sticky;
    top: 0;
    z-index: 10;
  }
  
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  
  .main {
    background: #f0f2f5;
    padding: 20px;
  }
  
  .content-wrapper {
    background: #fff;
    border-radius: 6px;
    padding: 20px;
    min-height: calc(100vh - 100px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
  </style>
  